<template>
    <Layout>
        <div slot="main" class="home-bg">
            <div class="success-block" v-show="isSuccess">
                <p class="title-line"><img src="../../style/success_icon.png" alt=""><strong>{{lang.buySuccess}}</strong></p>
                <p><img src="../../style/app_qrcode.png" alt=""></p>
                <p><small>{{lang.app}}</small></p>
                <p><router-link :to="{name: 'service'}" class="btn-submit">{{lang.ok}}</router-link></p>
            </div>
        </div>
    </layout>
</template>

<script>
import getLang from '@/utils/main/language';
import Layout from '@/views/Layout.vue';

export default {
    name: 'pay',
    components: {
        Layout,
    },
    data() {
        return {
            isCn: window.localStorage.getItem('show-lang') !== 'en',
            lang: getLang(),
            isSuccess: true,
        };
    },
    mounted() {
    },
    methods: {
    },
};
</script>
<style lang="less" scoped>
    .home-bg {
        background: #F8FAF9;
    }
    .success-block {
        width: 100%;
        height: 576px;
        background: #fff;
        p {
            text-align: center;
            font-size: 12px;
            line-height: 18px;
        }
        .title-line {
            display: flex;
            justify-content: center;
            align-items: center;
            margin: 0 auto;
            max-width: 540px;
            text-align: left;
            word-break: break-word;
            font-size: 16px;
            line-height: 16px;
            padding-top: 66px;
            padding-bottom: 60px;
            img {
                margin-right: 8px;
            }
        }
        .code-line {
            img {
                width: 250px;
                height: 250px;
            }
        }
        .btn-submit {
            display: inline-block;
            margin-top: 50px;
            padding: 7px 44px;
            line-height: 22px;
            font-size: 16px;
            background: #C71F4B;
            color: #fff;
        }
    }
</style>
